import React from 'react'
import {
  StyledErrorPage,
  ImageWrapper,
  Title,
  Subtitle,
  BrandLogoWrapper,
} from './ErrorPage.styled'
import { Button } from '@clickcease/cc-client-components-lib'
import { ErrorRobot } from 'Assets/icons/ErrorRobot'
import { useTranslation } from 'react-i18next'
import { ErrorMsg } from 'Assets/icons/404msg'
import { CQEssentialsLogo } from 'Assets/icons/CQEssentialsLogo'

export const ErrorPage: React.FC = () => {
  const { t } = useTranslation('general')

  const handleRefresh = () => {
    window.location.assign(window.location.origin)
  }

  return (
    <StyledErrorPage>
      <BrandLogoWrapper>
        <CQEssentialsLogo width="130px" />
      </BrandLogoWrapper>
      <ImageWrapper>
        <ErrorRobot />
        <ErrorMsg />
      </ImageWrapper>
      <Title>{t('error_page.title')}</Title>
      <Subtitle>{t('error_page.subtitle')}</Subtitle>
      <Button text={t('error_page.button')} onClick={handleRefresh} />
    </StyledErrorPage>
  )
}
